import { useRouter } from 'next/router';
import { useState } from 'react';
import { TokenResult } from '@/hooks/explore/useTokenSearch';
import { TokenWithMetadata } from '@/hooks/explore/useTrendingTokens';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useSession } from '@/contexts/LitSessionProvider';
import { SearchPageProps } from '../../mobile/SearchHome';
import TopMobileResults from '../../TopMobileResults';
import NativeTokenItem from './NativeTokenItem';
export type TTimeFrame = '24' | '12' | '4' | '1';
export type MobileDesktopResultsType = SearchPageProps & {
  resultsToUse: TokenResult[] | TokenWithMetadata[];
  timeFrame: TTimeFrame;
  setKeyword?: (_: string) => void;
  mode?: string;
};
export default function TopTokensResults({
  resultsToUse,
  timeFrame,
  onTokenClick,
  mode
}: MobileDesktopResultsType) {
  const router = useRouter();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const {
    PKP
  } = useSession();
  const [isModalOpen, setIsOpenModal] = useState(false);
  function handleTokenClick(tokenItem: any) {
    if (tokenItem?.symbol === 'ETH' && mode === 'native') {
      setIsOpenModal(true);
      return;
    }
    if (isModalOpen) {
      return;
    }
    if (onTokenClick) {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.search.clickToken,
        category: CATEGORIES.search,
        metaData: {
          tokenAddress: tokenItem?.address,
          network: tokenItem.networkId
        }
      });
      onTokenClick(tokenItem);
    } else {
      router.push(`/asset?address=${tokenItem?.address}&networkId=${tokenItem?.networkId}`);
    }
  }
  return <>
      {resultsToUse?.map((searchResult, index) => {
      const tokenItem = searchResult?.token;
      return <div key={index}>
            {mode === 'top' ? <TopMobileResults searchResult={searchResult} timeFrame={timeFrame} onTokenClick={handleTokenClick} /> : <NativeTokenItem tokenItem={tokenItem} timeFrame={timeFrame} searchResult={searchResult} handleTokenClick={handleTokenClick} onTokenClick={onTokenClick} mode={mode} />}
          </div>;
    })}
    </>;
}